<template>
  <div >
    <div style="width:80%">
      <el-collapse v-model="activeNames" @change="handleChange" accordion>
        <el-collapse-item title="展会时间安排 " name="1">
          <div>
            <el-table :data="tableData" style="width: 100%"> 
              <el-table-column   prop="name"   label="展台搭建期"   width="220"> </el-table-column> 
              <el-table-column   prop="date"   label="日期 "   width="220"> </el-table-column> 
              <el-table-column   prop="time"   label="时间"> </el-table-column>
            </el-table>

            <el-table :data="tableData1" style="width: 100%"> 
              <el-table-column   prop="name"   label="展览期"   width="220">
                
              </el-table-column> 
              <el-table-column   prop="date"   label="日期 "   width="220">
                <template slot-scope="scope"><div v-html="scope.row.date"></div></template>
              </el-table-column> 
              <el-table-column   prop="time"   label="时间">
                <template slot-scope="scope"><div v-html="scope.row.time"></div></template>
              </el-table-column>
            </el-table>

            <el-table :data="tableData2" style="width: 100%"> 
              <el-table-column   prop="name"   label="撤馆期"   width="220"> </el-table-column> 
              <el-table-column   prop="date"   label="日期 "   width="220"> </el-table-column> 
              <el-table-column   prop="time"   label="时间"> </el-table-column>
            </el-table>

            <div class="tip">
              <p>注意:</p>
              <p><span>a.</span>展商应严格遵守上述日期安排。</p>
              <p><span>b.</span>对于申请特装展台而言，如果展台搭建进度允许，展品可以提前到达展台。请联系指定货运商安排具体事宜。</p>
              <p><span>c.</span>我们建议展商在展览的最后一天结束时开始整理展品及其携带物品。应提前与指定货运商联系。展览一结束即将拆除标准展台，展商应及时去除展板上有用的宣传资料或海报。</p>
              <p><span>d.</span> 展览会期间，展商可以提前 30 分钟进馆，并可以于闭展后在馆内逗留 30 分钟。展商工作人员应于开展前 15 分钟到达展台。</p>
              <p><span>e.</span> 8 月 30 日下午 2 点观众停止入场；下午 3 点开始断电。</p>
              <p>以上安排如有变动，组织单位现场办公室将发放最新安排给到展商。</p>
            </div>

          </div>
        </el-collapse-item>

        <el-collapse-item title="重要联系" name="2">
          <div class="lxWarp">
            <div class="item">
                <div class="itemTitle">组织单位（主办方）</div>
                <div>
                    <p class="smallTtiel">中国食品土畜进出口商会</p>
                    <p>联系人：魏娜 女士</p>
                    <!-- <p>电话：(86) 10-87109840</p> -->
                    <P>电邮：weina@cccfna.org.cn</P>

                    <p class="smallTtiel">中国果品流通协会</p>
                    <p>联系人：提文赞 先生</p>
                    <p>电话：(86) 10-87109840</p>
                    <P>电话：15011505934</P>

                </div>
            </div>

            <div class="item">
                <div class="itemTitle">组织单位（承办方）</div>
                <div>
                    <p class="smallTtiel">上海茂恒会展有限公司 </p>
                    <p>上海市徐汇区淮海西路 55 号申通信息广场206A 室</p>
                    <p>联系人：林诗韵 女士魏菁 女士</p>
                    <P>电话：19301254949<br/>18501685932</P>
                    <p>电邮：ivy.lin@fruitexpo.cn<br/>jessica.wei@fruitexpo.cn</p>
                </div>
            </div>


            <div class="item">
                <div class="itemTitle">展览场地</div>
                <div>
                    <p class="smallTtiel">上海新国际博览中心有限公司</p>
                    <p>上海浦东新区龙阳路 2345 号</p>
                    <p>电话：(86) 21- 28906888</p>
                    <P>传真：(86) 21- 28906866</P>
                    <P>电邮：info@sniec.net</P>
                    <P>网址：www.sniec.net</P>
                </div>
            </div>


            <div class="item">
                <div class="itemTitle">超高或双层展台审图单位</div>
                <div>
                    <p class="smallTtiel">上海汉海展览咨询有限公司</p>
                    <p>上海市浦东新区龙阳路 2345 号 E2 馆 E2-2E1</p>
                    <P>联系人：顾倩 女士</P>
                    <p>电话：(86) 21-28906633 /34/35*809</p>
                    <P>传真：(86) 21-28906000</P>
                    <p>电邮：hah@hahchina.com</p>
                </div>
            </div>


            <div class="item">
                <div class="itemTitle">主场货运商</div>
                <div>
                    <p class="smallTtiel">上海罗杰斯国际展览报关服务有限公司</p>
                    <p>上海市兴义路 48 号 新世纪广场 A 座 1803 室</p>
                    <P>联系人：任永刚 先生 / 梁兴旺 先生</P>
                    <P>电话：(86) 21- 62700003</P>
                    <P>传真：(86) 21- 62700005</P>
                    <P>电邮：info@rogerssha.com</P>
                </div>
            </div>

            

            <div class="item">
                <div class="itemTitle">主场搭建商</div>
                <div>
                    <p class="smallTtiel">上海创隅展览展示有限公司</p>
                    <p>联系人：王道伟 先生</p>
                    <P>电话：19921238017</P>
                    <P>电邮：cyexpo@vip.163.com</P>
                </div>
            </div>



            <div class="item">
                <div class="itemTitle">保险公司</div>
                <div>
                    <p class="smallTtiel">会展风险管理网</p>
                    <p>会展风险管理经理</p>
                    <P>联系人：李欣 、陈伟君</P>
                    <P>电话：(86) 21-51113250<br/>18217731507、18217730796</P>
                </div>
            </div>


            <div class="item">
                <div class="itemTitle">指定旅游代理商</div>
                <div>
                    <p class="smallTtiel">上海奥润特会展服务有限公司</p>
                    <p>上海市漕溪路251弄3号楼801室</p>
                    <P>联系人：刘志强先生</P>
                    <P>电话：(86) 21 51099795</P>
                    <P>手机号：17321367242</P>
                    <P>电邮：booking@orient-explorer.com.cn</P>
                </div>
            </div>

            <div class="item">
                <div class="itemTitle">特装展台搭建审图监理单位</div>
                <div>
                    <p class="smallTtiel">安选会展科技（上海）有限公司</p>
                    <p>联系人：胡伟政 先生 /葛伟超 先生</p>
                    <P>电话：21-69957319/7316</P>
                    <P>电邮：CIFE@opt-safe.com</P>
                </div>
            </div>

          </div>
        </el-collapse-item>

      </el-collapse>
    </div>
    <div style="display:flex;padding-top:20px">
      <div style="margin-right:50px"><el-button type="primary" ><a :href="demoExcel" style="font-size:14px;color:#fff;text-decoration:none;"  target="_blank">基本信息下载.pdf</a></el-button></div>
      <div><el-button type="primary" ><a :href="demoExcel1" style="font-size:14px;color:#fff;text-decoration:none;"  target="_blank">规章制度下载.pdf</a></el-button></div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'ExhNotice',
  data: () => ({
      demoExcel:'./基本信息.pdf',
      demoExcel1:'./规章制度.pdf',
      activeNames:['1','2'],
      tableData: [{
        date: '2024 年 8 月 26-27 日 ',
        name: '进馆搭建',
        time: '09:00-22:00'
      }, {
        date: '2024 年 8 月 26-27 日 ',
        name: '展商登记（特装展商）',
        time: '09:00-17:30'
      }, {
        date: '2024 年 8 月 27 日 ',
        name: '展商登记（标准展位展商） ',
        time: '09:00-17:30'
      }],
      tableData1: [{
        date: '2024 年 8 月 28-29 日<br/>2024 年 8 月 30 日',
        name: '展览开放时间',
        time: '09:00-17:30<br/>09:00-15:00'
      }],
      tableData2: [{
        date: '2024 年 8 月 30 日',
        name: '归还租赁物品（电话，家具，电源开关等）',
        time: '16:00-17:30'
      }, {
        date: '2024 年 8 月 30 日 ',
        name: '展品撤馆',
        time: '15:00-22:00'
      }, {
        date: '2024 年 8 月 30 日 ',
        name: '撤馆结束 ',
        time: '22:00'
      }]
        
  }),
  components: {

  },
  methods: {
    handleChange(val) {
        console.log(val);
      }
  }
}
</script>
<style lang="less" scope>
.el-collapse-item__header{
  font-weight: bold !important;
  font-size: 16px;
}
.tip{
  font-size: 14px;
  padding:20px 10px;
}
.tip p{
  display: flex;
}
.tip p span{
  margin-right: 8px;
}
.lxWarp{
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-around;
}
.lxWarp .item{
 border: 1px solid #EBEEF5;
 padding: 10px;
 margin-bottom: 10px;
 width: 30%;
 margin-right: 2%;
}
.lxWarp .item .itemTitle{
  font-weight: bold;
  font-size: 16px;
  padding: 4px 0;
}
.lxWarp .item .smallTtiel{
  font-weight: bold;
  font-size: 14px;
}
</style>
